import React, { useState } from "react";
import "./scholarshipSection.scss";
import shar from "../../../assets/sharbc.png";
import tetgelegbc from "../../../assets/2.1tetgeleg.png";
import pdfFile from "../../../assets/Тэтгэлэг.pdf";
import { useNavigate } from "react-router-dom";
import { FaDownload } from "react-icons/fa";
import { HiArrowNarrowRight } from "react-icons/hi";

const formUrl =
  "https://docs.google.com/forms/d/e/1FAIpQLSdk3Lq9I0SOI9hSNDm6ih_csbmjcxC3V7rIU9kQQFFeKzPEYw/viewform?usp=dialog";

const tabs = [
  {
    key: "requirements",
    label: "Тэтгэлэгийн Шалгуур",
    title: "Тэтгэлэг Хөтөлбөр 2026-2027",
    description:
      "Монгол Улсын магадлан итгэмжлэгдсэн их, дээд сургуулийн бакалаврын зэрэгийн 2, 3, 4-р курсын оюутнуудад зориултай тэтгэлэгт хөтөлбөр бөгөөд өрхийн зорилготой, суралцах чин хүсэл эрмэлзэлтэй, эх оронч сэтгэлтэй оюутнуудыг дэмжинэ.",
    points: [
      "Голч дүн 3.2 ба түүнээс дээш",
      "Эх оронч хандлага, ёс зүйтэй",
      "Өрхийн орлогын нөхцөл байдлыг харгалзана",
    ],
    note: "Боломжийг зөв хүнд олгоно.",
    buttonText: "Удирдамж татах",
    action: "download",
    link: pdfFile,
  },
  {
    key: "amount",
    label: "Тэтгэлэгийн Хэмжээ",
    title: "Тэтгэлэгийн Хэмжээ",
    description:
      "Тэтгэлгийн хэмжээ нь суралцагчийн амжилт, оролцоо, нийгмийн идэвх болон тухайн жилийн хөтөлбөрийн санхүүжилтээс хамааран шатлалтайгаар олгогдоно.",
    points: [
      "Сургалтын төлбөрийн дэмжлэг",
      "Амжилтын урамшуулал",
      "Хөтөлбөрийн тусгай нэмэлт боломж",
    ],
    note: "Амжилттай суралцагч бүрт боломж нээлттэй.",
    buttonText: "Дэлгэрэнгүй харах",
    action: "route",
    link: "/scholarship",
  },
  {
    key: "apply",
    label: "Тэтгэлэгт Хүсэлт Өгөх",
    title: "Тэтгэлэгт Хүсэлт Илгээх",
    description:
      "Хүсэлт илгээхдээ өөрийн мэдээлэл, сурлагын дүн, тодорхойлолт болон шаардлагатай бусад материалуудыг үнэн зөв бөглөж илгээнэ үү.",
    points: [
      "Маягтыг бүрэн бөглөх",
      "Хавсралт файлуудаа оруулах",
      "Хугацаандаа илгээх",
    ],
    note: "Таны хүсэлтийг баг шалгаж, эргэн мэдэгдэнэ.",
    buttonText: "Хүсэлт илгээх",
    action: "external",
    link: formUrl,
  },
];

const ScholarshipSection = () => {
  const [activeTab, setActiveTab] = useState("requirements");
  const navigate = useNavigate();

  const currentTab = tabs.find((item) => item.key === activeTab) || tabs[0];

  const renderButton = (tab) => {
    const baseClass =
      "flex justify-center rounded-full border-[1px] border-gray-300 items-center px-12 py-4 gap-6 select-none cursor-pointer font-semibold hover:bg-white hover:text-black hover:border-black";

    if (tab.action === "download") {
      return (
        <a href={tab.link} download className="scholarshipSection__actionBtn">
          <div >{tab.buttonText}</div>
          <FaDownload />
        </a>
      );
    }

    if (tab.action === "external") {
      return (
        <div
          className="scholarshipSection__actionBtn"
          onClick={() => window.open(tab.link, "_blank")}
        >
          <div>{tab.buttonText}</div>
          <HiArrowNarrowRight />
        </div>
      );
    }

    if (tab.action === "route") {
      return (
        <div className="scholarshipSection__actionBtn" onClick={() => navigate(tab.link)}>
          <div>{tab.buttonText}</div>
          <HiArrowNarrowRight />
        </div>
      );
    }
  };

  return (
    <section className="scholarshipSection">
      <div className="scholarshipSection__container">
        <h2 className="scholarshipSection__heading">Тэтгэлэг</h2>

        <div className="scholarshipSection__content">

          <div className="scholarshipSection__left ">

            <div className="scholarshipSection__tabs">
              {tabs.map((tab) => (
                <button
                  key={tab.key}
                  type="button"
                  className={`scholarshipSection__tab ${
                    activeTab === tab.key
                      ? "scholarshipSection__tab--active"
                      : ""
                  }`}
                  onClick={() => setActiveTab(tab.key)}
                >
                  {tab.label}
                </button>
              ))}
            </div>

            <div className="scholarshipSection__body">
              <h3 className="scholarshipSection__title">
                {currentTab.title}
              </h3>

              <p className="scholarshipSection__description">
                {currentTab.description}
              </p>

              <ul className="scholarshipSection__list">
                {currentTab.points.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>

              <div className="scholarshipSection__note">
                <span className="scholarshipSection__noteIcon">✨</span>
                <span>{currentTab.note}</span>
              </div>

              <div className="mt-6">{renderButton(currentTab)}</div>
            </div>
          </div>

          <div className="scholarshipSection__right mr-0 lg:mr-0">
            <div className="scholarshipSection__imageWrap">
              <img src={shar} alt="bg" className="scholarshipSection__bg" />
              <img
                src={tetgelegbc}
                alt="student"
                className="scholarshipSection__image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScholarshipSection;